import React, { Component } from "react";
import 'tippy.js/dist/tippy.css';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

class AdminPortListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formOpen: false,
            formData: {}
        }
    }
    componentDidMount() {
        let serverUrl = 'http://localhost:9000/';
        if (process.env.NODE_ENV === 'development') serverUrl = 'http://localhost:9000/'
        else if (process.env.NODE_ENV === 'production') serverUrl = window.location.protocol + '//' + window.location.host + '/';
        this.setState({ serverUrl: serverUrl, formData: structuredClone(this.props.port) });


    }
    render() {
        const port = this.props.port ? this.props.port : { name: '', scalerank: 3, zone: '', radius: 3000, lat: '', long: '' };

        return (
            <li key={port._id} className='listItem'>
                <Formik
                    initialValues={{ name: port.name, scalerank: port.scalerank, zone: port.zone, radius: port.radius, lat: port.lat, long: port.long, deletePort: false }}
                    validationSchema={Yup.object({
                        name: Yup.string()
                            .required('Veuillez renseigner un nom'),
                        scalerank: Yup.number()
                            .required('Veuillez renseigner un rang'),
                        zone: Yup.number()
                            .required('Veuillez renseigner une zone'),
                        radius: Yup.number()
                            .required('Veuillez renseigner une radius'),
                        lat: Yup.string()
                            .required('Veuillez renseigner une latitude'),
                        long: Yup.string()
                            .required('Veuillez renseigner une longitude'),
                    })}
                    onSubmit={(values) => {
                        console.log('submit')
                        this.submitPort(values);
                    }}>
                    <Form>
                        <h2 className='boatName'> <Field name="name" type="text" placeholder="Port"></Field></h2><br />
                        Rang : <Field name="scalerank" type="number" placeholder="3"></Field><br />
                        zone : <Field name="zone" type="number" placeholder="0"></Field>
                        radius : <Field name="radius" type="number" placeholder="3000"></Field>



                        <div className='boatInfo'><span><Field name="lat" type="text" placeholder="0"></Field></span>,
                            <span><Field name="long" type="text" placeholder="0"></Field></span></div>

                        <div className="formError">
                            <p><ErrorMessage name="name" /></p>
                            <p><ErrorMessage name="scalerank" /></p>
                            <p><ErrorMessage name="zone" /></p>
                            <p><ErrorMessage name="radius" /></p>
                            <p><ErrorMessage name="lat" /></p>
                            <p><ErrorMessage name="long" /></p>
                            <p><ErrorMessage name="deletePort" /></p>
                        </div>

                        Delete ? <Field type="checkbox" name="deletePort" /><br />
                        <input type="submit" value="Valider" />
                    </Form>
                </Formik>
            </li>
        );
    }
    submitPort(values) {
        console.log(values)
        let changedValues = {}
        let action = '';
        if (this.props.port) {
            const oldValues = this.props.port;
            changedValues._id = oldValues._id;

            if (oldValues.name != values.name) changedValues.name = values.name;
            if (oldValues.rank != values.rank) changedValues.rank = values.rank;
            if (oldValues.zone != values.zone) changedValues.zone = values.zone;
            if (oldValues.radius != values.zone) changedValues.radius = values.radius;
            if (oldValues.lat != values.lat) changedValues.lat = values.lat;
            if (oldValues.long != values.long) changedValues.long = values.long;

            action = 'updatePort';
            if (values.deletePort) {
                action = 'deletePort';

            }
        } else {
            changedValues = values;
            action = 'createPort';
        }
        // console.log(changedValues)

        if (Object.keys(changedValues).length > 0) {
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(changedValues)
            }
            fetch(this.state.serverUrl + "admin/" + action, options)
                .then(res => res.json().then(json => {
                    if (json.message === 'success') {
                        console.log(action + ' successful!')
                        this.props.getPortData();
                    }
                }));
        }
    }


}


export default AdminPortListItem;
